module.exports = __webpack_public_path__ + "2db263ca1f088fd74a759ff46ee570c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meredicte/cte_logo.jpg
// module id = 324
// module chunks = 1